export class GetBinData {
    constructor(payload) {
      
      this.entityCode = payload?.entityCode ?? '';
      
    }
  }